import React from "react";
import api from "../../utils/api";

type FoodReportData = {
    totalRefunds: number;
    thisMonthRefunds: number;
    todayRefunds: number;
};

const FoodReport: React.FC = () => {
    const [refundData, setRefundData] = React.useState<FoodReportData>({
        totalRefunds: 0,
        thisMonthRefunds: 0,
        todayRefunds: 0,
    });
    const userId = JSON.parse(localStorage.getItem("user")!).userId;
    const fetchData = async () => {
        const response = await api.get('/api/DashboardReport/GetDashboardReport?UserId='+userId);
        if (response.status === 200) {
            const data = response.data?.dashboardReport[2] || {};
            setRefundData({
                totalRefunds: data.totalGrandAmount || 0,
                thisMonthRefunds: data.monthlyGrandAmount || 0,
                todayRefunds: data.todayGrandAmount || 0,
            });
        }
    };
    React.useEffect(() => {
        fetchData();
    }, []);

    const cardDetails = [
        {
            label: "Total Income",
            value: refundData.totalRefunds,
            icon: <i className="fas fa-rupee-sign fs-2 text-primary"></i>,
            color: "#e3f2fd",
        },
        {
            label: "Monthly Income",
            value: refundData.thisMonthRefunds,
            icon: <i className="fas fa-calendar-alt fs-2 text-secondary"></i>,
            color: "#fce4ec",
        },
        {
            label: "Today Income",
            value: refundData.todayRefunds,
            icon: <i className="fas fa-calendar-day fs-2 text-success"></i>,
            color: "#e8f5e9",
        },
    ];
    return (
        <div className='page-body'>
            <div className="container py-4">
                <h5 className="mb-4">Food Report</h5>
                <div className="row g-4">
                    {cardDetails.map((card) => (
                        <div className="col-12 col-sm-6 col-md-4" key={card.label}>
                            <div
                                className="card shadow-sm"
                                style={{ minWidth: 220, background: card.color }}
                            >
                                <div className="card-body">
                                    <div className="d-flex align-items-center mb-3">
                                        <span>{card.icon}</span>
                                        <span className="ms-3 h6 mb-0">{card.label}</span>
                                    </div>
                                    <div className="h4 fw-bold">
                                        ₹ {card.value.toLocaleString()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FoodReport;